import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { BRAND } from '../theme/tokens';
import {
  RECONCILE_STEPS, reconcileStepIndex, type ReconcileStepId,
} from '../utils/billReconcileFlow';

export interface BillReconcileStepStripProps {
  currentStep: ReconcileStepId;
  nextHint?: string;
}

export const BillReconcileStepStrip: React.FC<BillReconcileStepStripProps> = ({
  currentStep, nextHint,
}) => {
  const currentIdx = reconcileStepIndex(currentStep);

  return (
    <Box className="no-print" sx={{ mb: 1.5 }}>
      <Box sx={{
        display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap',
        p: 1, borderRadius: 1.5, border: '1px solid #e8e8ec', backgroundColor: '#fafafa',
      }}>
        {RECONCILE_STEPS.map((step, idx) => {
          const done = idx < currentIdx;
          const active = idx === currentIdx;
          return (
            <React.Fragment key={step.id}>
              {idx > 0 && (
                <Typography sx={{ fontSize: '0.62rem', color: '#ccc', px: 0.25 }}>→</Typography>
              )}
              <Box sx={{
                display: 'inline-flex', alignItems: 'center', gap: 0.4,
                px: 1, py: 0.35, borderRadius: 1,
                backgroundColor: active ? '#f3edfc' : done ? '#e8f5e9' : 'transparent',
                border: active ? `1px solid ${BRAND}44` : '1px solid transparent',
              }}>
                {done ? (
                  <CheckCircleIcon sx={{ fontSize: 13, color: '#2e7d32' }} />
                ) : (
                  <Typography sx={{
                    fontSize: '0.62rem', fontWeight: 800, color: active ? BRAND : '#aaa',
                    width: 14, textAlign: 'center',
                  }}>
                    {idx + 1}
                  </Typography>
                )}
                <Typography sx={{
                  fontSize: '0.72rem', fontWeight: active ? 800 : 600,
                  color: active ? BRAND : done ? '#2e7d32' : '#888',
                }}>
                  {step.short}
                </Typography>
              </Box>
            </React.Fragment>
          );
        })}
      </Box>
      {nextHint && (
        <Typography sx={{ fontSize: '0.68rem', color: '#666', mt: 0.75, lineHeight: 1.45 }}>
          <Box component="span" sx={{ fontWeight: 700, color: BRAND, mr: 0.5 }}>Next:</Box>
          {nextHint}
        </Typography>
      )}
    </Box>
  );
};

export default BillReconcileStepStrip;
